import { z } from 'zod';

/** Флаги одноразового UI-онбординга (#187). */
export const MeOnboardingUiDto = z.object({
  showWelcomeGiftModal: z.boolean(),
  showProfileEditHint: z.boolean(),
});
export type MeOnboardingUiDto = z.infer<typeof MeOnboardingUiDto>;
